import { Drawer, DrawerHeader } from "@components/v2";

import { OrdersTable } from "./orders-table";
import { OrdersTableSettings } from "./orders-table-settings";
import { type QuickFilter } from "./types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  selectedQuickFilter: QuickFilter;
}

export const MaximizeTableDrawer = (props: Props) => {
  return (
    <Drawer
      bodyClassName="bg-v2-primary flex flex-col gap-6 overflow-hidden"
      size={"calc(100% - 110px"}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <div className="flex flex-col">
        <DrawerHeader onClose={props.onClose}>Orders Table</DrawerHeader>
      </div>
      <div className="relative flex flex-col flex-1 gap-4 overflow-auto">
        <OrdersTableSettings selectedQuickFilter={props.selectedQuickFilter} />
        <OrdersTable
          tableClassName="h-[calc(100%-56px)]"
          className="overflow-auto mb-0 h-full"
          selectedQuickFilter={props.selectedQuickFilter}
        />
      </div>
    </Drawer>
  );
};
